import { BaseItemStore } from "../core/BaseStore";
import type FeedbackModel from "./FeedbackModel";

export default class FeedbackStore extends BaseItemStore<FeedbackModel> {}
